// Household-required guard.
//
// Pages under /household, /registration, /sleeve are meaningless without a
// selected household. CLIENTS always have exactly one (auto-selected), so they
// never hit this. But a NON-client (Advisor / Representative / Admin) can reach
// these routes with nothing chosen — in which case send them to the /advisor
// household selector instead of rendering an empty shell.
//
// Runs CLIENT-SIDE only: these routes are ssr:false and the active household
// lives in the tab-session store (sessionStorage, restored synchronously by
// pinia-plugin-persistedstate), so a hard refresh with a household already
// selected is NOT bounced. auth.global.ts runs first (alphabetical order), so
// useAuth().me is populated before the role check here.
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  const needsHousehold = /^\/(household|registration|sleeve)(\/|$)/.test(to.path)
  if (!needsHousehold) return

  const { hasAnyRole } = useAuth()
  const isNonClient = hasAnyRole(['Admin', 'Admin.Read', 'Admin.Write', 'Advisor', 'Representative'])
  if (!isNonClient) return

  const tab = useTabSessionStore()
  const hasHousehold = !!tab.householdId || !!tab.household?.id
  if (!hasHousehold) return navigateTo('/advisor', { replace: true })
})
